import { useDocs } from 'data/data'
import { Link } from 'react-router'

import SortableHeader from './SortableHeader'

function Table() {

    let headers = [
        { id: "facility", label: "Facility" },
        { id: "summary", label: "Summary" },
        { id: "region", label: "Region" },
        { id: "statute", label: "Statute" },
        { id: "document", label: "Document" },
        { id: "year", label: "Year" },
        { id: "pages", label: "Pages", sortable: false },
        { id: "file_size", label: "File Size", sortable: false },
        { id: "added", label: "Added" },
        { id: "link", label: "Link", isHidden: true },
        { id: "audit_notes", label: "Audit Notes", isHidden: true },
        { id: "associated_file", label: "Associated File", isHidden: true },
        { id: "date_filed", label: "Date of Document"},
        { id: "frs_id", label: "FRS ID"},
        { id: "program_id", label: "Program ID"},
        { id: "external_link", label: "External Link", isHidden: true },
        { id: "file_source", label: "File Source"},
        { id: "file_name", label: "Filename" }
    ]

    const { docs, sort, applySort, isLoading } = useDocs();

    let headersJsx = headers.map((a, index) => {
        if (a.isHidden)
            return false;
        if (a.sortable === false)
            return <th key={index}>{a.label}</th>;
        return (
            <SortableHeader key={index} name={a.id} label={a.label} currentSort={sort} onClick={(newSort) => applySort(newSort) } />
        )
    })

    const getFileName = (filename) => (filename || '').split('/').slice(-1)[0]

    if (isLoading === true) {
        return <div></div>
    }

    const getCellValue = (a, id, getFileName, updatedAt) => {
        switch (id) {
            case "facility": return (
                <Link to={`/document?id=${a.hash_id}`} className="file-name-main-link">
                    <div className="file-name-main">{a.facility}</div>
                </Link>
            )
            case "summary": return (
                <div className="file-name-cell">
                    <div className="file-name-summary">{a.doc_summary || a.summary || ""}</div>
                </div>
            )
            case "region": return a.region
            case "statute": return <span className={a.statute ? "badge " + a.statute.toLocaleLowerCase() : ""}>{a.statute}</span>
            case "document": return <span className={a.document ? "badge " + a.document.toLocaleLowerCase() : ""}>{a.document}</span>
            case "year": return a.year
            case "pages": return a.num_pages || a.pages || 'N/A'
            case "file_size": return a.file_size
            case "added": return updatedAt.toLocaleDateString()
            case "audit_notes": return a.audit_notes
            case "associated_file": return a.associated_file
            case "date_filed": return a.date_filed ? String(a.date_filed).slice(0, 10) : 'N/A'
            case "frs_id": return a.frs_id
            case "program_id": return a.program_id
            case "external_link": return a.external_link
            case "file_source": return a.file_source
            case "file_name": return (
                <Link to={`/document?id=${a.hash_id}`} className="file-name-main-link">
                    <div className="file-name-main">{getFileName(a.file_name)}</div>
                </Link>
            )
            default: return null
        }
    }

    let resultsJsx = docs.map((a) => {
        let updatedAt = new Date(a.added)
        return (
            <tr key={a.hash_id}>
                {headers.filter(h => !h.isHidden).map(h => (
                    <td key={h.id}>{getCellValue(a, h.id, getFileName, updatedAt)}</td>
                ))}
            </tr>
        )
    })

    return (
        <div className="tbl-wrap" >
            <table>
                <thead>
                    <tr>
                        {headersJsx}
                    </tr>
                </thead>
                <tbody>
                    {resultsJsx}
                </tbody>
            </table>
        </div >
    )
}

export default Table;